export default Object.freeze({
  New: 1,
  Submitted: 2,
  PendingRequisition: 3,
});
